export const carNumberLetters = /[ABCEHKMOPTXАВСЕНКМОРТУХabcehkmoptxавсенкмортух]/;
export const russianLetters = /[А-Яа-я]/;
export const latinLettersAndDigits = /[A-Za-z0-9]/;
export const russianLetterOrNumber = /[А-Яа-я0-9]/;